import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

interface ProfileData {
  company_name: string | null;
  logo_url: string | null;
  avatar_url: string | null;
  email?: string | null;
}

export function useProfileQuery() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["profile", user?.id],
    queryFn: async (): Promise<ProfileData | null> => {
      if (!user?.id) return null;
      
      const { data, error } = await supabase
        .from("profiles")
        .select("company_name, logo_url, avatar_url, email")
        .eq("id", user.id)
        .single();
      
      if (error) throw error;
      return data;
    },
    enabled: !!user?.id,
    staleTime: 30000, // 30 seconds - allows refetch when invalidated
    gcTime: Infinity,
    placeholderData: keepPreviousData,
  });
}
